<template>
    <section class="select-model">
        <div class="select-model__container container">
            <h2 class="configurator-title">Configure your new {{ manufacturer }}</h2>

            <p class="line-limiter">Select your favourite {{ manufacturer }} from the range below and build your perfect
                car from
                start to finish. Choose a colour to express your unique personality and once finished, save, share or
                enquire with your local Stellantis &You UK {{ manufacturer }} dealer.</p>

            <Card>
                <LoadingSpinner v-if="loading"></LoadingSpinner>

                <ul class="select-model__grid" v-else>
                    <li class="select-model__grid--item" v-for="model in newModels" :key="model.id">
                        <router-link
                            :to="{name: 'select-gearbox', params: {brand: this.brand, urlModel: model.url_model}}"
                            @click.native="nextStep"
                            class="flex">
                            <picture v-if="model.image">
                                <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp"/>
                                <img class="img-responsive select-model__image" :src="model.image"
                                    :alt="model.model_title"/>
                            </picture>
                            <div>
                                <p class="select-model__title margin-bottom-0">
                                    {{ model.model_title.replace("Citroen", "Citroën").replace('fiat', 'Fiat').replace('abarth', 'Abarth') }}
                                </p>
                                <p class="configurator__price">
                                    from <span class="configurator__price--accent">£{{
                                        model.min_price_formatted
                                    }}</span>
                                </p>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </Card>
        </div>

        <ResumeConfigurationModal v-if="localStorageData" :open="isModalVisible" @close-resume-configuration-modal="closeModal"/>
    </section>
</template>

<script>
import LoadingSpinner from "../../core/components/LoadingSpinner";
import ResumeConfigurationModal from "../components/ResumeConfigurationModal";
import EventObject from "../../modules/tracking/EventObject";

import {mapState} from "vuex";

export default {
    props: {
        brand: {
            type: String,
            required: true,
        }
    },
    components: {
        LoadingSpinner,
        ResumeConfigurationModal
    },
    data() {
        return {
            loading: true,
            newModels: [],
            isModalVisible: false
        }
    },
    methods: {
        getModelsByBrand: async function (brand) {
            const response = await axios.get(`/api/configurator/new-model/${brand}`);
            return response.data.data;
        },

        closeModal: function () {
            this.isModalVisible = false;
        },

        nextStep: function () {
            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 1 of 7: Select gearbox").dispatch();
        }
    },
    async created() {
        this.$store.commit('setBrand', this.brand);
        this.$store.commit('setManufacturer', this.brand);
        this.newModels = await this.getModelsByBrand(this.brand);
        document.title = `Configurator | Configure My New ${this.manufacturer} Car`
        this.loading = false;

        if (!this.$route.query.id && localStorage.getItem(`configurator-${this.brand}`)) {
            this.isModalVisible = true;
        }
    },
    computed: {
        ...mapState(['manufacturer']),

        localStorageData() {
            return JSON.parse(localStorage.getItem(`configurator-${this.brand}`));
        }
    }
}
</script>

<style lang="scss" scoped>
.line-limiter {
    max-width: 979px;
}

.configurator__price {
    text-align: center;
    color: #243782;
    margin-top: 0;

    &--accent {
        font-weight: 700;
        color: #EF7D00;
    }
}

.margin-bottom-0 {
    margin-bottom: 0;
}

.flex {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/pages/SelectModel.vue